module.exports = __webpack_public_path__ + "assets/1ab84e13c211aa487e2223eba28f9633.png";